import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CollectionApiClient, IPaginationResponse } from '../../../../core';
import { UtilityManagementCollections } from '../../../..';
import {
  IInboxNotificationResponse,
  IMarkAllNotificationsAsSeenResponse,
  IMyNotificationPaginationParameters,
  INotificationFilterParameters,
  IUnseenNotificationsCountResponse,
  INotificationLookupResponse
} from '../dtos';
import { IMyNotificationsApiClient } from './i-my-notifications-api.client';

@Injectable({
  providedIn: 'root'
})
export class MyNotificationsApiClient implements IMyNotificationsApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(UtilityManagementCollections.MyNotifications, http);
  }

  get(paginationParameters?: IMyNotificationPaginationParameters): Observable<IPaginationResponse<IInboxNotificationResponse>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getById(id: string): Observable<IInboxNotificationResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  getUnseenCount(filter?: INotificationFilterParameters): Observable<IUnseenNotificationsCountResponse> {
    return this.collectionApiClient.get({
      collectionName: UtilityManagementCollections.myNotificationsUnseenCount(),
      paginationParameters: filter
    });
  }

  markAsSeen(id: string): Observable<void> {
    return this.collectionApiClient.put({
      id,
      resourceSegment: 'seen'
    });
  }

  markAllAsSeen(filter?: INotificationFilterParameters): Observable<IMarkAllNotificationsAsSeenResponse> {
    return this.collectionApiClient.put({
      collectionName: UtilityManagementCollections.myNotificationsSeen(),
      paginationParameters: filter
    });
  }

  getLookups(): Observable<INotificationLookupResponse> {
    return this.collectionApiClient.get({
      collectionName: UtilityManagementCollections.notificationLookups()
    });
  }
}
